import { render, staticRenderFns } from "./ModalRequerimiento.vue?vue&type=template&id=5a7afe7e&"
import script from "./ModalRequerimiento.vue?vue&type=script&lang=ts&"
export * from "./ModalRequerimiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports